import { useState } from 'react';

export default function Footer() {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email) return;

    const formData = new URLSearchParams();
    formData.append('email', email);

    try {
      await fetch('https://readdy.ai/api/form/d8r5ud8n4gr6p3b2gdi0', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: formData.toString(),
      });
      setSubmitted(true);
      setEmail('');
    } catch {
      setSubmitted(true);
    }
  };

  return (
    <footer className="w-full bg-foreground-900 px-6 md:px-10 lg:px-16 rounded-t-3xl mx-auto max-w-[calc(100%-2rem)] mt-8">
      <div className="py-12 md:py-16">
        {/* Top: 3 columns */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-8 mb-12">
          {/* Column 1: Subscribe */}
          <div className="md:col-span-1">
            <h3 className="text-2xl md:text-3xl font-heading font-light text-white mb-3">
              Stay Updated
            </h3>
            <p className="text-sm text-white/50 mb-5 leading-relaxed">
              Get the latest Litbuy Spreadsheet guides and tips delivered to your inbox.
            </p>
            <form onSubmit={handleSubmit} className="flex flex-col gap-3" data-readdy-form="">
              <input
                type="email"
                name="email"
                placeholder="Your email address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="bg-transparent border-b border-white/20 text-white text-sm py-2 px-1 placeholder-white/30 focus:outline-none focus:border-white/50 transition-colors"
                required
              />
              <button
                type="submit"
                className="inline-flex items-center gap-2 px-5 py-2 rounded-full bg-white text-foreground-900 font-medium text-sm hover:bg-white/90 transition-all duration-200 w-fit whitespace-nowrap cursor-pointer"
              >
                Subscribe
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-line"></i>
                </span>
              </button>
              {submitted && (
                <p className="text-xs text-accent-400 mt-1">Thanks for subscribing!</p>
              )}
            </form>
          </div>

          {/* Column 2: Navigate */}
          <div>
            <h4 className="text-sm font-semibold text-white uppercase tracking-wider mb-4">
              Navigate
            </h4>
            <div className="flex flex-col gap-3">
              <a href="/" className="text-sm text-white/60 hover:text-white transition-colors duration-200 border-b border-transparent hover:border-white/30 pb-0.5 w-fit whitespace-nowrap">
                Home
              </a>
              <a href="/about" className="text-sm text-white/60 hover:text-white transition-colors duration-200 border-b border-transparent hover:border-white/30 pb-0.5 w-fit whitespace-nowrap">
                About
              </a>
              <a href="/safety" className="text-sm text-white/60 hover:text-white transition-colors duration-200 border-b border-transparent hover:border-white/30 pb-0.5 w-fit whitespace-nowrap">
                Safety &amp; Disclaimer
              </a>
              <a href="/faq" className="text-sm text-white/60 hover:text-white transition-colors duration-200 border-b border-transparent hover:border-white/30 pb-0.5 w-fit whitespace-nowrap">
                FAQ
              </a>
              <a href="/contact" className="text-sm text-white/60 hover:text-white transition-colors duration-200 border-b border-transparent hover:border-white/30 pb-0.5 w-fit whitespace-nowrap">
                Contact
              </a>
            </div>
          </div>

          {/* Column 3: Contact */}
          <div>
            <h4 className="text-sm font-semibold text-white uppercase tracking-wider mb-4">
              Contact
            </h4>
            <div className="flex flex-col gap-3">
              <a href="mailto:hello@litbuyspreadsheets.pics" className="text-sm text-white/60 hover:text-white transition-colors duration-200 whitespace-nowrap">
                hello@litbuyspreadsheets.pics
              </a>
              <a
                href="https://kaspreadsheet.com/"
                target="_blank"
                rel="noopener nofollow"
                className="text-sm text-white/60 hover:text-white transition-colors duration-200 whitespace-nowrap"
              >
                Visit Main Website &rarr;
              </a>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4 pt-8 border-t border-white/10">
          {/* Social links */}
          <div className="flex items-center gap-5">
            <a
              href="https://twitter.com/"
              target="_blank"
              rel="noopener nofollow"
              className="text-xs text-white/50 hover:text-white/80 transition-colors duration-200 border-b border-transparent hover:border-white/30 pb-0.5 whitespace-nowrap"
            >
              Twitter / X
            </a>
            <a
              href="https://pinterest.com/"
              target="_blank"
              rel="noopener nofollow"
              className="text-xs text-white/50 hover:text-white/80 transition-colors duration-200 border-b border-transparent hover:border-white/30 pb-0.5 whitespace-nowrap"
            >
              Pinterest
            </a>
            <a
              href="https://reddit.com/"
              target="_blank"
              rel="noopener nofollow"
              className="text-xs text-white/50 hover:text-white/80 transition-colors duration-200 border-b border-transparent hover:border-white/30 pb-0.5 whitespace-nowrap"
            >
              Reddit
            </a>
          </div>

          {/* Copyright */}
          <p className="text-xs text-white/40 text-center">
            &copy; {new Date().getFullYear()} litbuyspreadsheets.pics. All rights reserved.
          </p>

          {/* Policy links */}
          <div className="flex items-center gap-4">
            <a href="/safety" className="text-xs text-white/50 hover:text-white/80 transition-colors duration-200 whitespace-nowrap">
              Privacy
            </a>
            <a href="/safety" className="text-xs text-white/50 hover:text-white/80 transition-colors duration-200 whitespace-nowrap">
              Terms
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}